var React = require('react');

function BreadcrumbAppsIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"svg-fill","fillRule":"evenodd"},[React.createElement("rect",{"width":"5","height":"5","key":0}),React.createElement("rect",{"width":"5","height":"5","y":"8","key":1}),React.createElement("rect",{"width":"5","height":"5","x":"7","key":2}),React.createElement("rect",{"width":"5","height":"5","x":"7","y":"8","key":3})]));
}

BreadcrumbAppsIcon.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13"};

module.exports = BreadcrumbAppsIcon;

BreadcrumbAppsIcon.default = BreadcrumbAppsIcon;
